export const GlobalVariable = Object.freeze({
  BASE_API_URL: "https://stage.centralmed.com.ar/",
  BASE_FRONT_URL: "https://stage.centralmed.com.ar/",
  // BASE_LUCKYEXCEL_URL: "https://stage-xls.centralmed.com.ar/?xls=",
    BASE_LUCKYEXCEL_URL: "http://localhost:3000/?xls=",
  BASE_LUCKYEXCEL_URL_PROD:
    "http://localhost/Ludela/CentralMED/frontend/Luckyexcel/dist/?xls=",
  VERSION_FRONT: "6.0.0",
  VERSION_BACK: "6.0.0",
});
